import { Component, inject } from "@angular/core";
import { AuthService } from "@kno2/core/auth";
import { DialogBodyComponent, DialogFooterComponent, DialogService } from "@kno2/shared/dialog";

@Component({
    selector: "kno2-account-organization-canceled-modal",
    imports: [DialogBodyComponent, DialogFooterComponent],
    templateUrl: "./account-organization-canceled-modal.component.html"
})
export class AccountOrganizationCanceledModalComponent {
    private readonly authService = inject(AuthService);
    private readonly dialogService = inject(DialogService);

    protected async logout(): Promise<void> {
        this.dialogService.close();
        await this.authService.logout();
    }
}
